module.exports = __webpack_public_path__ + "img/clipboard.3828545c.png";